<template>
  <Modal :id="'cmp-add-currency'" @cancelled="onCancel" :loadingFlag="loading">
    <template slot="header"
      >{{ isEditMode ? $t("edit") : $t("add") }} {{ $t("territory") }}</template
    >
    <template slot="body">
      <div class="form-group">
        <TextField
          class="m1"
          :id="'territory_name'"
          required
          :showValidationIcons="true"
          :immediateValidation="true"
          v-bind="textFieldConfig"
          v-model="territory_name"
          isModel
          @validated="onValidation"
          :placeholder="$t('new_territory_name')"
        />
        <Dropdown
          class="dt-dropdown m2"
          :options="regionsTV"
          :selected="selectedRegion"
          :placeholder="$t('select_predefined')+` ${$t('territory')}`"
          v-on:selectedChange="e => onRegionSelect(e)"
          box
        />
      </div>
      <SearchList
        :id="'countries'"
        :multiColumn="true"
        :items="filteredCountries"
        :selected="selectedCountries"
        :keyProperty="countryKey"
        :label="'country_fullname'"
        :isSearchable="false"
        @selected="onCountrySelected"
      ></SearchList>

    

 

    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $t("cancel") }}
      </button>
      <button style="max-width: 150px;" :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid" class="dt-button v1 with-ico s1" @click.stop="onAddTerritory">
        <div class="dt-icon-container">
          <img src="static/icons/plus-white.svg" class="dt-icon v7" alt />
        </div>
        <div  class="button-text">
          {{
            isEditMode
              ? `${$t("edit")} ${$t("territory")}`
              : isAddMode
              ? `${$t("add")} ${$t("new")} ${$t("territory")}`
              : ""
          }}
        </div>
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { GeneralSettingService } from "../../services/general-settings.service";
import SearchList from "@dtplugins/search-list/search-list";
import { tv } from "../../../../models/text-value.model";
import { wait } from "../../../../utility";

export default {
  components: {
    Modal,
    SearchList
  },
  props: {},
  mounted: async function() {
    const territoryRes = await GeneralSettingService.findTerritory({
      territory_id: this.territory_id
    });

    const territoryData = territoryRes.data;
    console.log(territoryData.data);
    this.territory = territoryData.territory;
    this.countries = territoryData.countries;
    this.regions = territoryData.regions;

    this.territory_name = this.territory.territory_name;

    if (this.isEditMode) {
      await wait(1000);
      this.selectedCountries = new Set(
        this.countries
          .filter(country => country.external_id == this.territory.territory_id)
          .map(e => e.main_country_id)
      );
      console.log(this.selectedCountries);
    }
  },
  data: function() {
    return {
      loading: false,
      regions: [],
      countries: [],
      territory: {},
      territory_name: "",
      selecteditems:new Set(),
      countryKey: "main_country_id",
      selectedRegion: { text: "All", value: "all" },

      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false
      },
      validationResult:{},
      selectedCountries: null
      // Mark: Data
    };
  },
  watch: {},
  computed: {
    regionsTV: function() {
      console.log(
        this.regions
          .map(tv("region", "region"))
          .map(e => {
            if (e.value === "") {
              return {
                value: "all",
                text: "All"
              };
            } else {
              return e;
            }
          })
          .sort((a, b) => b.value - a.value)
      );
      return [
        { text: "All", value: "all" },
        ...this.regions.map(tv("region", "region")).filter(e => {
          if (e.value === "") {
            return false;
          } else {
            return true;
          }
        })
      ];
    },
    filteredCountries: function() {
      return this.selectedRegion.value == "all"
        ? this.countries
        : this.countries.filter(e => e.region == this.selectedRegion.value);
    },
    isEditMode: function() {
      return this.$route.query.modal === "edit_territory";
    },
    isAddMode: function() {
      return this.$route.query.modal === "add_territory";
    },
    territory_id: function() {
      return this.$route.query.territory_id;
    },
    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e.valid);
    },
  },
  methods: {
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onValidation: function(name, value) {
      this.$set(this.validationResult, name, value);
      console.log(this.validationResult);
    },
    onAddTerritory: async function() {
      this.loading = true;

      const newTerritory = await GeneralSettingService.insertNewTerritory({
        territory_id: this.territory_id,
        territory_name: this.territory_name,
        countries: JSON.stringify(
          Array.from(this.selectedCountries).map(countryId => {
            return {
              country_id: countryId,
              country_relation_id: "",
              selected: 1
            };
          })
        )
      });

      console.log(
        this.isEditMode
          ? "Territory Succesfully Edited"
          : this.isAddMode
          ? "Territory Succefully Added."
          : "Territory Status Unknown."
      );

      // if (this.isAddMode) {
      // } else {
      //   const editedTerritory = await GeneralSettingService.insertNewTerritory({
      //     territory_id: this.territory_id,
      //     territory_name: this.territory_name,
      //     countries: JSON.stringify(
      //       Array.from(this.selectedCountries).map(countryId => {
      //         return {
      //           country_id: countryId,
      //           country_relation_id: "",
      //           selected: ""
      //         };
      //       })
      //     )
      //   });
      // }

      const territoriesRes = await GeneralSettingService.findTerritories();

      this.$emit("added", territoriesRes.data);
      // if (this.isAddMode) {
      // } else {
      // }
    },
    onCountrySelected: function(selectedCountries) {
      this.selectedCountries = selectedCountries;
    },
    onRegionSelect: function(value) {
      this.selectedRegion = value;
    }
    // Mark: Methods
  }
};
</script>

<style lang="scss" scoped>
// .ckeditor-container {
//   .ck-editor {
//     width: 100%;
//   }

// }
.dt-button.with-ico {
  padding: 0 5px 0 0;
}
.dt-input-box--container {
  // margin: 5px !important;
  // margin-left: 0px !important;
}
</style>
